import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "@apollo/client"
import {split} from "@apollo/client/link/core"
import {onError} from "@apollo/client/link/error"

import {createAuthLink, createUnauthorizedRetryLink} from "./auth/authLinks"
import CommonUtils from "./utils/Common"

CommonUtils.GetSettingInit()

// URL des API
const CommonUrl = CommonUtils.GetSetting("COMMON_API_URL")
const BusinessUrl = CommonUtils.GetSetting("BUSINESS_API_URL")

const logLink = onError(({graphQLErrors, networkError}) => {
    graphQLErrors?.forEach(({message, locations, path}) =>
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    )

    if (networkError) {
        console.error(`[Network error]: ${networkError}`)
    }
})

// Routes to the right API based on the clientName the operation carries.
const httpLink = split(
    (operation) => operation.getContext().clientName === "CommonUrl",
    new HttpLink({uri: CommonUrl}),
    new HttpLink({uri: BusinessUrl})
)

export const cache = new InMemoryCache({
    addTypename: false,
    dataIdFromObject: undefined
})

/**
 * The link order carries the session logic:
 *   1. `logLink` observes without intervening;
 *   2. `createUnauthorizedRetryLink` catches 401s, forces a renewal and replays
 *      the operation;
 *   3. `createAuthLink` renews the token when it is close to expiring, then
 *      stamps the headers — it sits below the retry link, so a replay re-stamps
 *      the fresh token on its way down;
 *   4. `httpLink` sends the request.
 */
const apolloClient = new ApolloClient({
    link: ApolloLink.from([logLink, createUnauthorizedRetryLink(), createAuthLink(), httpLink]),
    cache
})

export default apolloClient
